import { createFileRoute } from '@tanstack/react-router'
import { MenuPage } from '~/features/listing-menus/components/menu-page'

export const Route = createFileRoute('/dashboard/menu')({
  validateSearch: (search: Record<string, unknown>) => ({
    listingId: typeof search.listingId === 'string' ? search.listingId : undefined,
  }),
  component: MenuRoute,
})

function MenuRoute() {
  const { listingId } = Route.useSearch()
  return <MenuPage key={listingId} listingId={listingId} />
}
